<div
  class="alert alert-danger mt-2"
  *ngIf="
    validationControl.hasError(validationName) &&
    (validationControl.dirty || validationControl.touched)
  "
>
  {{ errorMessage }}
</div>
